import React, { useState } from "react";
import "./EmailTemplatePreview.css";

const EmailTemplatePreview = () => {
  const [selectedTemplate, setSelectedTemplate] = useState("welcome");
  const [studentName, setStudentName] = useState("Clinton Bongani Khoza");

  // Study Pack Welcome Email Template
  const studyPackTemplate = `<!doctype html>
<html>
  <body style="margin:0;padding:0;background:#f5f5f5;font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;">
    <style>
      /* Desktop and large screens */
      @media only screen and (min-width: 601px) {
        .header-title { color: #ffffff !important; }
      }
      /* Mobile + small screens */
      @media only screen and (max-width: 600px) {
        .container { width: 100% !important; border-radius: 0 !important; }
        .header-title { font-size: 28px !important; color: #ffffff !important; }
        .cta { display: block !important; width: 90% !important; margin-left: auto !important; margin-right: auto !important; }
        .pad { padding: 20px !important; }
        .dual img { width: 92% !important; display: block !important; margin: 10px auto !important; }
      }
      /* Extra small screens */
      @media only screen and (max-width: 400px) {
        .header-title { font-size: 24px !important; color: #ffffff !important; }
      }
    </style>
 
    <table role="presentation" width="100%" cellspacing="0" cellpadding="0">
      <tr>
        <td align="center" style="padding:32px 10px;">
          <table role="presentation" width="640" class="container" cellspacing="0" cellpadding="0" style="background:#ffffff;border-radius:16px;overflow:hidden;box-shadow:0 6px 20px rgba(0,0,0,0.15);">
              <!-- Header -->
            <tr>
              <td style="background:#2b3640;color:#ffffff;text-align:center;padding:36px 24px;border-bottom:6px solid #e0593e;">
                <img src="https://firebasestorage.googleapis.com/v0/b/andus-education.appspot.com/o/TPC%2FTechPerformanceCentre%2Femail-images%2Fwelcome-pack--nav%20(2).png?alt=media&token=c2ba2662-6f2b-4d74-ad27-2ba1749ed5dc" alt="TPC" style="width:905px;height:20vh;display:block;margin:0 auto 25px;border:0;outline:none;opacity:0.8;border-radius:12px;"/>
                <div class="header-title" style="font-size:40px;line-height:1.1;font-weight:800;letter-spacing:1px;">
                  WELCOME,<br/>${studentName}
              </div>
                <div class="cta" style="margin-top:16px;background:#e0593e;color:#fff;display:inline-block;padding:12px 20px;border-radius:40px;font-weight:700;">
                  YOU DID IT! Your path to greatness STARTS HERE 🎯
                </div>
              </td>
            </tr>
 
            <!-- Body / Intro -->
            <tr>
              <td class="pad" style="padding:28px 32px;color:#2c3e50;text-align:center;">
                <p style="margin:0 0 18px;font-size:18px;line-height:1.6;">
                  Access your <strong>WELCOME PACK</strong> to see what your TPC journey has in store. In it you'll find your course <strong>BROCHURE</strong> and see how TPC will take you from zero to <strong>TECH HERO</strong> 🚀
                </p>
                <a href="https://heyzine.com/flip-book/3721a97c06.html" class="cta" style="display:inline-block;margin-top:8px;padding:14px 28px;background:#FAC516;color:#2F3E4B !important;text-decoration:none;border-radius:40px;font-weight:800;border:3px solid #2F3E4B;">
                  WELCOME PACK
                </a>
              </td>
            </tr>
 
            <!-- Visual band + note -->
            <tr>
              <td style="background:#2b3640;padding:28px 24px;text-align:center;">
                <p style="color:#e9eef2;font-size:18px;line-height:1.7;margin:16px auto 6px;max-width:680px;">
                  By selecting this course, you've taken a step toward self‑improvement, personal development and growth – that takes guts! We look forward to walking this journey with you.
                </p>
              </td>
            </tr>
 
            <!-- Footer image -->
            <tr>
              <td style="padding:0;text-align:center;background:#f7f7f7;">
                <img src="https://firebasestorage.googleapis.com/v0/b/andus-education.appspot.com/o/TPC%2FTechPerformanceCentre%2Femail-images%2Fwelcome-pack-email-footer.png?alt=media&token=b10e47fd-23f7-4ed1-85d6-cfe027a35acf" alt="TPC Footer" style="width:100%;height:auto;display:block;"/>
              </td>
            </tr>
          </table>
        </td>
      </tr>
    </table>
  </body>
</html>`;

  const currentTemplate = studyPackTemplate;

  return (
    <div className="email-preview-container">
      <div className="email-preview-controls">
        <h1>Email Template Preview</h1>
        <div className="controls">
          <div className="control-group">
            <label>Template:</label>
            <select value={selectedTemplate} onChange={(e) => setSelectedTemplate(e.target.value)}>
              <option value="welcome">Study Pack Welcome Email</option>
            </select>
          </div>
          <div className="control-group">
            <label>Student Name:</label>
            <input
              type="text"
              value={studentName}
              onChange={(e) => setStudentName(e.target.value)}
              placeholder="Enter student name"
            />
          </div>
        </div>
      </div>

      <div className="email-preview-frame">
        <iframe
          srcDoc={currentTemplate}
          title="Email Template Preview"
          className="email-iframe"
        />
      </div>
    </div>
  );
};

export default EmailTemplatePreview;
